import { ParcelSummary } from './ParcelSummary.js';


import  displayWinSchoolDistrictInfo from '../../SummaryTools/Winnebago/displaySchoolDistrictInfo.js'
import  displayZoningInfo  from '../../SummaryTools/displayZoningInfo.js';
import  displayPropertyUse  from '../../SummaryTools/Winnebago/displayPropertyUse.js';
import  displayTownshipInfo  from '../../SummaryTools/Winnebago/displayTownshipInfo.js';
import  displayFMVs  from '../../SummaryTools/Winnebago/displayFMVs.js';
import  displayExemptions from '../../SummaryTools/Winnebago/displayExemptions.js';
import  displaySalesHistory  from '../../SummaryTools/Winnebago/displaySalesHistory.js';

export class WinSummary extends ParcelSummary {
    #service;

    constructor(Pin, ParcelService, BasemapService, service) {
        if (new.target == WinSummary) {
            throw new Error("Abstract classes can't be instantiated.");
        }
        super(Pin, ParcelService, BasemapService);
        this.#service = service;

        this.summaryDivs.propertyUses = document.createElement('div');
        this.summaryDivs.zoning = document.createElement('div');
        this.summaryDivs.townshipInfo = document.createElement('div');
        this.summaryDivs.schoolDistrict = document.createElement('div');
        this.summaryDivs.taxInfo = document.createElement('div');
        this.summaryDivs.exemptions = document.createElement('div');
        this.summaryDivs.salesHistory = document.createElement('div');


    }

    async basicInit() {
        try {
            this.#service.getPropertyInfo(this.pin).then((propertyInfo) => {
                try {
                    this.summaryDivs.propertyUses.innerHTML = displayPropertyUse(propertyInfo.propertyUses);
                    this.summaryDivs.townshipInfo.innerHTML = displayTownshipInfo(propertyInfo.townshipInfos);
                    this.summaryDivs.taxInfo.innerHTML = displayFMVs(propertyInfo.fmvs);
                    this.summaryDivs.exemptions.innerHTML = displayExemptions(propertyInfo.exemptions);
                    this.summaryDivs.salesHistory.innerHTML = displaySalesHistory(propertyInfo.salesHistories);
                }
                catch {
                    this.handlePropertyException(); 
                }
                
            });
        }
        catch {
            this.handlePropertyException(); 
        }

        await super.basicInit();

        if (!this.optOut)
        {

            
                    this.#service.findZoningResults(this.geometry).then((results) => {
                        this.summaryDivs.zoning.innerHTML = displayZoningInfo(results); 
                    })
            
                    const schoolDistrictInfo = await this.#service.getSchoolDistrictInfo(this.geometry);
                    this.summaryDivs.schoolDistrict.innerHTML = displayWinSchoolDistrictInfo(schoolDistrictInfo);
        }

    }
    handlePropertyException() {
        this.summaryDivs.propertyUses.innerHTML = null;
        this.summaryDivs.townshipInfo.innerHTML = null;
        this.summaryDivs.taxInfo.innerHTML = null;
        this.summaryDivs.exemptions.innerHTML = null;
        this.summaryDivs.salesHistory.innerHTML = null;
        this.summaryErrors.innerHTML += "<span><b>There was an error getting the property use data.</b></span></br>"
        this.summaryErrors.innerHTML += "<span><b>There was an error getting the township data.</b></span></br>"
        this.summaryErrors.innerHTML += "<span><b>There was an error getting the tax data.</b></span></br>"
        this.summaryErrors.innerHTML += "<span><b>There was an error getting the exemption data.</b></span></br>"
        this.summaryErrors.innerHTML +="<span><b>There was an error getting the sale history data.</b></span></br>"
        console.error("Error getting property info.")
    }
}


